var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "page-breadcrumb" },
    [
      _c(
        "b-breadcrumb",
        [
          _c(
            "b-breadcrumb-item",
            { attrs: { to: { name: "admin" } } },
            [
              _c("b-icon", {
                attrs: {
                  icon: "house-fill",
                  scale: "1.25",
                  "shift-v": "1.25",
                  "aria-hidden": "true",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm._l(_vm.items, function (item, index) {
            return _vm.items.length
              ? _c(
                  "b-breadcrumb-item",
                  { key: index, attrs: { to: item.path } },
                  [_vm._v("\n      " + _vm._s(item.text) + "\n    ")]
                )
              : _vm._e()
          }),
          _vm._v(" "),
          _c("b-breadcrumb-item", { attrs: { active: "" } }, [
            _vm._v(_vm._s(_vm.name)),
          ]),
        ],
        2
      ),
      _vm._v(" "),
      !_vm.noTitle
        ? _c("h1", { staticClass: "page-title" }, [
            _vm._v(_vm._s(_vm.pageTitle)),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }